<template>
  <div data-test-path="sticky-notes-main" class="main">
    <div v-if="stickyNoteListVisible" class="sticky-notes">
      <transition name="fade">
        <div style="cursor: auto">
          <div style="position: relative" class="w-100">
            <div style="z-index: 999; position: absolute; left: 0; right: 0">
              <b-container fluid class="pl-0">
                <b-row class="w-100 no-gutters pb-2">
                  <b-col cols="auto" class="mt-3 ml-2">
                    <b-button
                        data-test-path="add-sticky-note-button"
                        @click="addStickyNote"
                        style="width: 40px; height: 40px; background-color: #ffff90"
                        class="pl-2">
                      <font-awesome-icon icon="plus" class="fa-xl" style="color: #243C59">
                      </font-awesome-icon>
                    </b-button>
                  </b-col>
                  <b-col class="mt-3 text-center">
                    <b-button @click="scrollUp" class="standard-button" style="background-color: #ffff90">
                      <font-awesome-icon icon="chevron-double-up" class="fa-xl"
                                         style="color: #243C59;"></font-awesome-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="mt-3 mr-2 text-right">
                    <b-button data-test-path="close-sticky-notes-button" @click="hideListOfStickyNotes"
                              style="width: 40px; height: 40px; background-color: #ffff90">
                      <font-awesome-icon
                          icon="times"
                          class="fa-xl"
                          style="color: #243C59">
                      </font-awesome-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </div>


          <div ref="listOfStickyNotes"
               style="z-index: 900; position: absolute; left: 0; right: 0; top: 0; bottom: 0; overflow: auto">
            <b-container fluid class="p-0"
                         style="background: rgba(255, 255, 255, 0.192); backdrop-filter: blur(2px);">

              <b-row class="no-gutters" style="padding-top: 65px">
                <b-col v-for="(stickyNote, index) in listOfStickyNotes" :key="stickyNote.id"
                       ref="stickyNote"
                       style="margin: 0 auto;" cols="auto" class="mb-2">
                  <StickyNoteCard
                      :sticky-note-id="stickyNote.id"
                      :sticky-note-list-visible="stickyNoteListVisible"
                      :sticky-note-index="index"
                  >
                  </StickyNoteCard>
                </b-col>
                <div>&nbsp;</div>
              </b-row>
            </b-container>
          </div>

          <div style=" z-index: 10000; position: absolute; left: 0; bottom: 0; right: 0">
            <b-container>
              <b-row class="w-100 no-gutters pt-3">
                <b-col class="text-center">
                  <b-button @click="scrollDown" class="standard-button" style="background-color: #ffff90">
                    <font-awesome-icon
                        icon="chevron-double-down"
                        class="fa-xl"
                        style="color: #243C59">
                    </font-awesome-icon>
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </transition>
    </div>

    <div v-else-if="listOfStuckStickyNotes.length > 0">
      <div v-for="(stickyNote, index) in listOfStuckStickyNotes" :key="stickyNote.id">
        <StickyNoteCard
            ref="stickyNoteCard"
            @setPositionStickyNote="setPositionStickyNote"
            :sticky-note-id="stickyNote.id"
            :free-card="true"
            :autofocus="stickyNote.autofocus"
            :list-of-stuck-sticky-notes="listOfStuckStickyNotes"
            :left-offset="stickyNote.leftOffset"
            :top-offset="stickyNote.topOffset"
            :sticky-note-list-visible="stickyNoteListVisible"
            :sticky-note-index="index"
        >
        </StickyNoteCard>
      </div>
    </div>
  </div>
</template>

<script>

import FooterButton from "@/components/navbar/FooterButton";
import StickyNoteCard from "@/components/sticky/StickyNoteCard";
import StickyNote from "@/server/com/silkplm/model/sticky/StickyNote";
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";

export default {
  name: "ListOfStickyNotes",
  components: {StickyNoteCard, FooterButton},

  async mounted() {

    this.$onUpdate(StickyNote, async (changeEvent) => {
      if (changeEvent.instance.isPinned) {
        let index = _.findIndex(this.listOfStuckStickyNotes, ['id', changeEvent.id]);
        if (index !== -1) {
          this.listOfStuckStickyNotes[index] = changeEvent.instance;
        } else {
          this.listOfStuckStickyNotes.push(changeEvent.instance);
        }
      } else{
        let index = _.findIndex(this.listOfStuckStickyNotes, ['id', changeEvent.id]);
        if (index !== -1) {
          this.listOfStuckStickyNotes.splice(index, 1);
        }
      }
      let index = _.findIndex(this.listOfStickyNotes, ['id', changeEvent.id]);
      if (index !== -1) {
        this.listOfStickyNotes[index] = changeEvent.instance;
      }
    });

    this.$onInsert(StickyNote, async (changeEvent) => {
      this.listOfStickyNotes.unshift(changeEvent.instance);
      if (changeEvent.instance.isPinned) {
        changeEvent.instance.autofocus = true;
        this.listOfStuckStickyNotes.push(changeEvent.instance);
      }
    });

    this.$onDelete(StickyNote, async (changeEvent) => {
      let index = _.findIndex(this.listOfStickyNotes, ['id', changeEvent.id]);
      if (index !== -1) {
        this.listOfStickyNotes.splice(index, 1);
      }
      index = _.findIndex(this.listOfStuckStickyNotes, ['id', changeEvent.id]);
      if (index !== -1) {
        this.listOfStuckStickyNotes.splice(index, 1);
      }

    });

    this.$onBulkChange(StickyNote, async (changeEvent) => {
      this.listOfStickyNotes = await Rpc.StickyNotes.listStickyNotes();
      this.listOfStuckStickyNotes = await Rpc.StickyNotes.listPinStickyNotes();
    });

    this.listOfStickyNotes = await Rpc.StickyNotes.listStickyNotes();
    this.listOfStuckStickyNotes = await Rpc.StickyNotes.listPinStickyNotes();
    this.setStickyNoteCards();
    window.addEventListener("resize", () => this.sizeChanged());
  },

  beforeDestroy() {
    document.removeEventListener("resize", () => this.sizeChanged());
  },

  methods: {
    sizeChanged() {
      if (!this.listOfStuckStickyNotes.length) {
        return;
      }
      for (let i = 0; i<this.listOfStuckStickyNotes.length; i++) {
        if(this.$refs.stickyNoteCard[i]){
          this.$refs.stickyNoteCard[i].sizeChanged();
        }
      }
    },

    setStickyNoteCards() {
      let leftOffset = 10;
      let topOffset = 65;
      for (let i = 0; i < this.listOfStuckStickyNotes.length; i++) {
        if (!this.listOfStuckStickyNotes[i].leftOffset && !this.listOfStuckStickyNotes[i].topOffset) {
          this.listOfStuckStickyNotes[i].leftOffset = leftOffset;
          this.listOfStuckStickyNotes[i].topOffset = topOffset;
          leftOffset += 30;
          topOffset += 30;
        }
      }
    },

    scrollDown() {
      this.$refs.listOfStickyNotes.scrollTop += this.$refs.stickyNote[0].clientHeight;
    },

    scrollUp() {
      this.$refs.listOfStickyNotes.scrollTop -= this.$refs.stickyNote[0].clientHeight;
    },

    async addStickyNote() {
      await Rpc.StickyNotes.addStickyNote();
    },

    async setPositionStickyNote(stickyNote, leftPosition, topPosition) {
      await Rpc.StickyNotes.setPositionOfStickyNote(stickyNote.id, leftPosition, topPosition);
    },

    hideListOfStickyNotes(){
      EventBus.$emit(Events.showOrHideStickyNotesList);
    }

  },

  props: {
    stickyNoteListVisible: {type: Boolean, default: false},
  },

  watch: {
    stickyNoteListVisible: function (val) {
      if (!val) {
        this.setStickyNoteCards();
      }
    },

  },

  data: () => ({
    listOfStickyNotes: [],
    listOfStuckStickyNotes: [],
  }),

}
</script>

<style lang="sass" scoped>

.sticky-notes
  position: absolute
  top: 55px
  left: 0
  height: calc(100vh - 75px)
  right: 0
</style>